import React from 'react';
import PubNub from "pubnub";

export const PubNubContext = React.createContext();

export const pubnub = new PubNub({
  publishKey: "pub-c-016609f4-c43a-4099-b05c-e23085c1f98c",
  subscribeKey: "sub-c-95ee1298-6201-11e9-ae53-666e2ad6cdf0"
});